import React, { createContext, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { signOut } from "firebase/auth";
import { auth } from "../config/firebase";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const authState = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authState.user && !authState.loading) {
      // Kiểm tra tài khoản bị vô hiệu hóa
      if (authState.user.trangThai === 'nghi') {
        signOut(auth);
        navigate('/login', { 
          replace: true, 
          state: { message: 'Tài khoản của bạn đã bị vô hiệu hóa. Liên hệ Admin!' }
        });
        return;
      }

      const isOnDoiMatKhau = location.pathname === '/doi-mat-khau';
      
      if (authState.user.lanDauDangNhap === true && !isOnDoiMatKhau) {
        navigate('/doi-mat-khau', { replace: true });
      } else if (authState.user.lanDauDangNhap === false && isOnDoiMatKhau) {
        navigate('/dashboard', { replace: true });
      }
    }
  }, [authState.user, authState.loading, location.pathname, navigate]);

  if (authState.loading) {
    return (
      <div style={{
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh', 
        fontSize: 18, 
        color: '#1a237e'
      }}>
        Đang tải...
      </div>
    );
  }

  return <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuthContext phải dùng trong AuthProvider");
  return context;
};